import React, { useEffect, useState } from "react";
import { BiSolidArrowFromBottom } from "react-icons/bi";
import "./ScrollNav.css";

const ScrollNav = ({ offset = 150, color = "#ffffff" }) => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      setShowTop(scrollY > offset);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [offset]);

  const smoothScrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  if (!showTop) return null;

  return (
    <div className="scrollnav-root" aria-hidden={!showTop}>
      <button
        className="scrollnav-top-btn"
        title="Scroll to top"
        onClick={smoothScrollToTop}
        aria-label="Scroll to top"
      >
        <span className="outer">
          <span className="inner">
            <BiSolidArrowFromBottom className="icon" style={{ color }} aria-hidden />
          </span>
        </span>
      </button>
    </div>
  );
};

export default ScrollNav;
